import { HTML_ESCAPE_REGEX } from '../constants/regex';

const HTML_ESCAPE_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

// Escapes text for HTML text content and quoted attribute values.
export const escapeHtml = (value) =>
  String(value ?? '').replace(HTML_ESCAPE_REGEX, (char) => HTML_ESCAPE_MAP[char]);
